import { createTrackingEvent } from '@/common/analytics/gtm/createTrackingEvent';

export const trackUserLogout = (): void => {
  createTrackingEvent({
    event: 'logout',
  });
};
